exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sms-textarea-wrapper[data-v-77e33fae]{border:1px solid #ddd;border-radius:4px;padding:6px}.sms-textarea[data-v-77e33fae]{border:0;-webkit-box-shadow:none;box-shadow:none;padding:0;resize:none}", ""]);

// exports
